const NAME = 'request';

export const ADD_OR_UPDATE = `${NAME}/ADD_OR_UPDATE`;
export const REMOVE = `${NAME}/REMOVE`;
export const SET_FAILED = `${NAME}/SET_FAILED`;
